import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import AOS from 'aos';
import 'froala-editor/js/froala_editor.pkgd.min.js';
import { Froala_Constants } from './app/utilities/constant';
import { registerFroalaImageAlignCommand } from './app/utilities/froala-image-align-command';
import { registerFroalaListIndentCommand } from './app/utilities/froala-list-indent-command';
import { registerFroalaTableBorderCommand } from './app/utilities/froala-table-border-command';

declare var FroalaEditor: any;
FroalaEditor.DEFAULTS.key = Froala_Constants.LICENSE_KEY;
registerFroalaImageAlignCommand();
registerFroalaListIndentCommand();
registerFroalaTableBorderCommand();

if (environment.production) {
  enableProdMode();
  console.log = (...arg) => { };
}
AOS.init(); // Initialize AOS

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
